const STATUS_OPTIONS = [
  { value: "DRAFT", label: "Entwurf (nur Admin)" },
  { value: "COMING_SOON", label: "In Vorbereitung (sichtbar)" },
  { value: "PUBLISHED", label: "Veröffentlicht" },
  { value: "INACTIVE", label: "Nicht öffentlich" },
];

const COLLECTIBLE_FORMAT_OPTIONS = [
  { value: "A6", label: "A6 (105 × 148 mm)" },
  { value: "TRADING_CARD", label: "Sammelkarte (63 × 88 mm)" },
  { value: "BOOKMARK", label: "Lesezeichen (70 × 200 mm)" },
];

const EXPERIENCE_MODE_OPTIONS = [
  { value: "LINEAR", label: "Geführter Weg" },
  { value: "OPEN_COLLECTION", label: "Freies Entdecken / Museum" },
];

const COMPLETION_RULE_OPTIONS = [
  { value: "ALL_STATIONS", label: "Alle Stationen abschließen" },
  { value: "ARTWORK_COUNT", label: "Anzahl Kunstwerke entdecken" },
];

export const SCHEMAS = {
  communities: {
    label: "Gemeinden",
    scoped: false,
    titleField: "name",
    fields: [
      { name: "name", label: "Gemeindename", type: "text", required: true },
      { name: "short_name", label: "Kurzname", type: "text" },
      { name: "logo_mark", label: "Kürzel (z.B. SR)", type: "text" },
      { name: "slug", label: "URL-Kürzel (slug)", type: "text" },
      { name: "subtitle", label: "Untertitel", type: "text" },
      { name: "description", label: "Introtext", type: "textarea" },
      { name: "logo", label: "Logo", type: "image" },
      { name: "hero_image", label: "Hero-/Startseitenbild", type: "image" },
      { name: "primary_color", label: "Primärfarbe", type: "color" },
      { name: "secondary_color", label: "Sekundärfarbe", type: "color" },
      { name: "accent_color", label: "Akzentfarbe", type: "color" },
      { name: "loser_word", label: "LOSER-Wort", type: "text" },
      { name: "address", label: "Adresse", type: "text" },
      { name: "website", label: "Website", type: "text" },
      { name: "contact_email", label: "Kontakt E-Mail", type: "text" },
      { name: "legal_imprint", label: "Impressum", type: "textarea" },
      { name: "legal_privacy", label: "Datenschutz", type: "textarea" },
      { name: "legal_terms", label: "Nutzungsbedingungen", type: "textarea" },
      { name: "legal_rules", label: "Community-Regeln", type: "textarea" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  walks: {
    label: "Wege",
    scoped: true,
    fields: [
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "subtitle", label: "Untertitel", type: "text" },
      { name: "category", label: "Kategorie", type: "text" },
      { name: "target_group", label: "Zielgruppe", type: "text" },
      { name: "short_description", label: "Kurzbeschreibung", type: "textarea" },
      { name: "description", label: "Beschreibung", type: "textarea" },
      { name: "hero_image", label: "Wegbild", type: "image" },
      { name: "distance_text", label: "Distanz (Text, z.B. ca. 1,9 km)", type: "text" },
      { name: "duration_text", label: "Dauer (Text, z.B. 30–45 Minuten)", type: "text" },
      { name: "start_location_text", label: "Start", type: "text" },
      { name: "end_location_text", label: "Ziel", type: "text" },
      { name: "experience_mode", label: "Erlebnisart", type: "select", options: EXPERIENCE_MODE_OPTIONS, defaultValue: "LINEAR" },
      { name: "completion_rule", label: "Abschlussbedingung", type: "select", options: COMPLETION_RULE_OPTIONS, defaultValue: "ALL_STATIONS" },
      { name: "completion_target", label: "Benötigte Anzahl entdeckter Werke", type: "text", defaultValue: "0" },
      { name: "require_favorite_for_completion", label: "Lieblingswerk für Abschluss erforderlich", type: "boolean" },
      { name: "completion_xp", label: "XP für Abschluss", type: "text", defaultValue: "100" },
      { name: "collectible_enabled", label: "Sammelkarte vergeben", type: "boolean", defaultValue: true },
      { name: "collectible_physical_enabled", label: "Zusätzlich als physische Karte erhältlich", type: "boolean" },
      { name: "collectible_format", label: "Kartenformat", type: "select", options: COLLECTIBLE_FORMAT_OPTIONS, defaultValue: "A6" },
      { name: "collectible_number", label: "Kartennummer (z.B. 001)", type: "text" },
      { name: "collectible_title", label: "Kartentitel", type: "text" },
      { name: "collectible_subtitle", label: "Karten-Untertitel", type: "text" },
      { name: "collectible_description", label: "Kartentext / Rückseite", type: "textarea" },
      { name: "collectible_front_image", label: "Fertige Kartenvorderseite", type: "image" },
      { name: "collectible_back_image", label: "Fertige Kartenrückseite", type: "image" },
      { name: "collectible_cognitive_url", label: "Link zum Gedankenraum", type: "text" },
      { name: "collectible_creator_label", label: "Gestalter-Credit", type: "text" },
      { name: "collectible_creator_url", label: "Link des Gestalters", type: "text" },
      { name: "status", label: "Status", type: "select", options: STATUS_OPTIONS },
      { name: "featured", label: "Hervorgehoben", type: "boolean" },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  stations: {
    label: "Stationen",
    scoped: true,
    filterBy: "walk_id",
    fields: [
      { name: "walk_id", label: "Weg", type: "ref", resource: "walks", required: true },
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "subtitle", label: "Untertitel", type: "text" },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "short_description", label: "Kurzbeschreibung", type: "textarea" },
      { name: "story_text", label: "Geschichte / Text", type: "textarea" },
      { name: "task_text", label: "Aufgabentext", type: "textarea" },
      { name: "instruction_text", label: "Anleitung", type: "textarea" },
      { name: "location_description", label: "Ortsbeschreibung (kein GPS nötig)", type: "textarea" },
      { name: "address", label: "Adresse (optional)", type: "text" },
      { name: "hero_image", label: "Stationsbild", type: "image" },
      { name: "latitude", label: "Latitude (optional)", type: "text" },
      { name: "longitude", label: "Longitude (optional)", type: "text" },
      { name: "modules", label: "Module", type: "modules" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  walk_segments: {
    label: "Wegabschnitte",
    scoped: true,
    filterBy: "walk_id",
    fields: [
      { name: "walk_id", label: "Weg", type: "ref", resource: "walks", required: true },
      { name: "from_station_id", label: "Von Station", type: "ref", resource: "stations" },
      { name: "to_station_id", label: "Zu Station", type: "ref", resource: "stations" },
      { name: "title", label: "Titel (z.B. Zum Stadtpark)", type: "text", required: true },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "instruction", label: "Wegbeschreibung", type: "textarea" },
      { name: "distance_text", label: "Distanz (Text, z.B. ca. 400 m)", type: "text" },
      { name: "duration_text", label: "Dauer (Text, z.B. 5–7 Minuten)", type: "text" },
      { name: "route_image", label: "Wegbild / Kartenbild", type: "image" },
      { name: "destination_image", label: "Zielbild („Hier musst du hin.“)", type: "image" },
      { name: "variant_key", label: "Varianten-Schlüssel (z.B. DIREKT)", type: "text" },
      { name: "variant_name", label: "Variantenname", type: "text" },
      { name: "variant_description", label: "Variantenbeschreibung", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  places: {
    label: "Orte",
    scoped: true,
    fields: [
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "description", label: "Beschreibung", type: "textarea" },
      { name: "location_description", label: "Ortsbeschreibung", type: "textarea" },
      { name: "address", label: "Adresse", type: "text" },
      { name: "image", label: "Bild", type: "image" },
      { name: "latitude", label: "Latitude (optional)", type: "text" },
      { name: "longitude", label: "Longitude (optional)", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  discovery_items: {
    label: "Entdeckungsinhalte",
    scoped: true,
    filterBy: "walk_id",
    fields: [
      { name: "walk_id", label: "Weg / Ausstellung", type: "ref", resource: "walks" },
      { name: "inventory_number", label: "Kennung", type: "text" },
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "subtitle", label: "Untertitel / aktueller Inhalt", type: "text" },
      {
        name: "content_type",
        label: "Inhaltstyp",
        type: "select",
        options: ["KUNST", "KULTUR", "POESIE", "INTERAKTION", "GESCHICHTE", "MÄRCHEN", "PERSON", "VEREIN", "BETRIEB", "NATUR", "HISTORISCHES_FOTO", "FUN_FACT", "AUDIO", "EIGENER_INHALT"].map((v) => ({ value: v, label: v })),
      },
      { name: "short_text", label: "Kurztext", type: "textarea" },
      { name: "long_text", label: "Langtext", type: "textarea" },
      { name: "instruction_text", label: "Anleitung / Handlung", type: "textarea" },
      { name: "interpretation_prompt", label: "Impulsfrage", type: "textarea" },
      { name: "location_description", label: "Standortbeschreibung", type: "textarea" },
      { name: "image", label: "Bild", type: "image" },
      { name: "gallery", label: "Weitere Bilder", type: "gallery" },
      { name: "audio", label: "Audio (optional)", type: "image", accept: "audio/*" },
      { name: "contributor_id", label: "Mitwirkender (optional)", type: "ref", resource: "contributors" },
      { name: "source", label: "Quelle", type: "text" },
      { name: "external_link", label: "Externer Link", type: "text" },
      { name: "external_link_label", label: "Link-Beschriftung", type: "text" },
      {
        name: "research_status",
        label: "Recherche-Status",
        type: "select",
        options: [
          { value: "PLAQUE_ONLY", label: "Nur Schild erfasst" },
          { value: "RESEARCH_IN_PROGRESS", label: "Teilweise recherchiert / Angaben offen" },
          { value: "RESEARCHED", label: "Recherchiert" },
          { value: "ARTIST_VERIFIED", label: "Von Urheber:in bestätigt" },
        ],
      },
      { name: "research_notes", label: "Interne Recherche-Notizen", type: "textarea" },
      {
        name: "rights_status",
        label: "Bild-/Textrechte",
        type: "select",
        options: [
          { value: "UNCLARIFIED", label: "Noch ungeklärt" },
          { value: "PILOT_INTERNAL", label: "Nur interne Pilotvorführung" },
          { value: "APPROVED", label: "Freigegeben" },
        ],
      },
      { name: "verification_notes", label: "Interne Freigabe-Notizen", type: "textarea" },
      { name: "order", label: "Sortierung", type: "text" },
      { name: "featured", label: "Als Highlight markieren", type: "boolean" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  artworks: {
    label: "Kunstwerke",
    scoped: true,
    filterBy: "walk_id",
    fields: [
      { name: "walk_id", label: "Weg / Ausstellung", type: "ref", resource: "walks", required: true },
      { name: "contributor_id", label: "Künstler:in", type: "ref", resource: "contributors" },
      { name: "inventory_number", label: "Inventarnummer", type: "text" },
      { name: "title", label: "Werktitel", type: "text", required: true },
      { name: "subtitle", label: "Untertitel", type: "text" },
      { name: "series_title", label: "Werkserie / Reihe", type: "text" },
      { name: "year", label: "Jahr", type: "text" },
      { name: "material", label: "Material / Technik", type: "text" },
      { name: "dimensions", label: "Maße", type: "text" },
      {
        name: "availability_status",
        label: "Verfügbarkeit",
        type: "select",
        options: [
          { value: "UNKNOWN", label: "Unbekannt" },
          { value: "ON_REQUEST", label: "Auf Anfrage" },
          { value: "NOT_FOR_SALE", label: "Unverkäuflich" },
        ],
      },
      { name: "price_text", label: "Preisangabe", type: "text" },
      { name: "plaque_text", label: "Abschrift des Schilds", type: "textarea" },
      { name: "short_description", label: "Kurzbeschreibung", type: "textarea" },
      { name: "description", label: "Hintergrund / Geschichte", type: "textarea" },
      { name: "artist_statement", label: "Stimme des Künstlers", type: "textarea" },
      { name: "interpretation_prompt", label: "Frage an Besucher:innen", type: "textarea" },
      { name: "image", label: "Werkfoto", type: "image" },
      { name: "gallery", label: "Weitere Werk-, Detail- und Schildfotos", type: "gallery" },
      { name: "audio", label: "Audio (optional)", type: "image", accept: "audio/*" },
      { name: "video", label: "Video-Link", type: "text" },
      { name: "location_description", label: "Standortbeschreibung", type: "textarea" },
      { name: "zone", label: "Bereich / Zone", type: "text" },
      { name: "latitude", label: "Latitude (optional)", type: "text" },
      { name: "longitude", label: "Longitude (optional)", type: "text" },
      { name: "official_url", label: "Offizielle Werkseite", type: "text" },
      { name: "source_url", label: "Recherchequelle", type: "text" },
      {
        name: "research_status",
        label: "Recherche-Status",
        type: "select",
        options: [
          { value: "PLAQUE_ONLY", label: "Nur Schild erfasst" },
          { value: "RESEARCH_IN_PROGRESS", label: "Teilweise recherchiert / Angaben offen" },
          { value: "RESEARCHED", label: "Recherchiert" },
          { value: "ARTIST_VERIFIED", label: "Vom Künstler bestätigt" },
        ],
      },
      { name: "research_notes", label: "Interne Recherche-Notizen", type: "textarea" },
      {
        name: "rights_status",
        label: "Bild-/Textrechte",
        type: "select",
        options: [
          { value: "UNCLARIFIED", label: "Noch ungeklärt" },
          { value: "PILOT_INTERNAL", label: "Nur interne Pilotvorführung" },
          { value: "APPROVED", label: "Freigegeben" },
        ],
      },
      { name: "verification_notes", label: "Interne Freigabe-Notizen", type: "textarea" },
      { name: "order", label: "Sortierung", type: "text" },
      { name: "featured", label: "Als Highlight markieren", type: "boolean" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  artwork_credits: {
    label: "Werk-Credits",
    scoped: true,
    fields: [
      { name: "artwork_id", label: "Kunstwerk", type: "ref", resource: "artworks", required: true },
      { name: "contributor_id", label: "Person / Organisation", type: "ref", resource: "contributors", required: true },
      {
        name: "role",
        label: "Rolle",
        type: "select",
        options: [
          { value: "ARTIST", label: "Künstler:in" },
          { value: "CO_ARTIST", label: "Mitwirkende:r Künstler:in" },
          { value: "FABRICATION", label: "Herstellung / Ausführung" },
          { value: "DONOR_LEGACY", label: "Schenkung / Vermächtnis" },
          { value: "CURATOR", label: "Kuration" },
          { value: "TEXT", label: "Text" },
          { value: "PHOTO", label: "Foto" },
          { value: "OTHER", label: "Andere Rolle" },
        ],
      },
      { name: "credit_label", label: "Öffentliche Credit-Zeile", type: "text" },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  contributors: {
    label: "Mitwirkende",
    scoped: true,
    titleField: "name",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      {
        name: "type",
        label: "Typ",
        type: "select",
        options: ["ARTIST", "PERSON", "AUTHOR", "CLUB", "BUSINESS", "ORGANIZATION", "EXPERT", "OTHER"].map((v) => ({ value: v, label: v })),
      },
      { name: "short_bio", label: "Kurzbio", type: "textarea" },
      { name: "description", label: "Beschreibung", type: "textarea" },
      { name: "profile_image", label: "Profilbild", type: "image" },
      { name: "website", label: "Website", type: "text" },
      { name: "portfolio", label: "Portfolio", type: "text" },
      { name: "social", label: "Social", type: "text" },
      { name: "country", label: "Land", type: "text" },
      { name: "city", label: "Ort", type: "text" },
      { name: "source_url", label: "Recherchequelle", type: "text" },
      {
        name: "research_status",
        label: "Recherche-Status",
        type: "select",
        options: [
          { value: "PLAQUE_ONLY", label: "Nur Schild erfasst" },
          { value: "RESEARCH_IN_PROGRESS", label: "Teilweise recherchiert / Angaben offen" },
          { value: "RESEARCHED", label: "Recherchiert" },
          { value: "ARTIST_VERIFIED", label: "Vom Künstler bestätigt" },
        ],
      },
      { name: "research_notes", label: "Interne Recherche-Notizen", type: "textarea" },
      { name: "verification_notes", label: "Interne Freigabe-Notizen", type: "textarea" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  challenges: {
    label: "Challenges",
    scoped: true,
    fields: [
      {
        name: "challenge_type",
        label: "Welche Art von Challenge?",
        type: "select",
        options: [
          { value: "SELF_CONFIRM", label: "Selbst bestätigen" },
          { value: "PHOTO_UPLOAD", label: "Foto-Upload" },
          { value: "VIDEO_UPLOAD", label: "Video-Upload" },
          { value: "ADMIN_CONFIRM", label: "Gemeinde bestätigt" },
          { value: "WITNESS_CONFIRM", label: "Zeuge bestätigt" },
          { value: "CODE_CONFIRM", label: "Code" },
          { value: "TIME_RESULT", label: "Zeit-Ergebnis" },
          { value: "NUMBER_RESULT", label: "Anzahl-Ergebnis" },
        ],
      },
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "short_description", label: "Kurzbeschreibung", type: "textarea" },
      { name: "description", label: "Beschreibung", type: "textarea" },
      { name: "instruction", label: "Anleitung", type: "textarea" },
      { name: "place_id", label: "Ort", type: "ref", resource: "places" },
      { name: "unit_label", label: "Einheit (z.B. Klimmzüge)", type: "text", showFor: ["NUMBER_RESULT", "TIME_RESULT", "WITNESS_CONFIRM"] },
      { name: "code", label: "Code", type: "text", showFor: ["CODE_CONFIRM"] },
      { name: "image", label: "Bild", type: "image" },
      { name: "rules_text", label: "Regeln", type: "textarea" },
      { name: "ranking_enabled", label: "Rangliste anzeigen", type: "boolean" },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  games: {
    label: "Spiele",
    scoped: true,
    fields: [
      {
        name: "game_type",
        label: "Spielart",
        type: "select",
        options: [
          { value: "SET_MATCH", label: "Satz-Match (z.B. Padel)" },
          { value: "SCORE_MATCH", label: "Ergebnis-Match" },
          { value: "LETTER_GAME", label: "Buchstaben-Spiel (LOSER)" },
        ],
      },
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "short_description", label: "Kurzbeschreibung", type: "textarea" },
      { name: "place_id", label: "Ort", type: "ref", resource: "places" },
      { name: "rules_text", label: "Regeln", type: "textarea" },
      { name: "image", label: "Bild", type: "image" },
      { name: "match_format", label: "Matchformat", type: "text", showFor: ["SET_MATCH"] },
      { name: "word", label: "Wort (z.B. LOSER)", type: "text", showFor: ["LETTER_GAME"] },
      {
        name: "confirmation_mode",
        label: "Bestätigung",
        type: "select",
        options: [
          { value: "OPPONENT_CONFIRM", label: "Gegner bestätigt" },
          { value: "SELF_CONFIRM", label: "Selbst bestätigen" },
        ],
        showFor: ["LETTER_GAME"],
      },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  achievements: {
    label: "Erfolge",
    scoped: true,
    fields: [
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "description", label: "Beschreibung", type: "textarea" },
      { name: "icon_or_image", label: "Bild / Icon", type: "image" },
      {
        name: "condition_type",
        label: "Bedingung",
        type: "select",
        options: [
          { value: "MANUAL", label: "Manuell" },
          { value: "WALK_COMPLETED", label: "Weg abgeschlossen" },
          { value: "WALKS_COMPLETED_COUNT", label: "Anzahl abgeschlossener Wege" },
          { value: "FIRST_CHALLENGE", label: "Erste Challenge" },
          { value: "FIRST_MATCH", label: "Erstes bestätigtes Match" },
          { value: "FIRST_LOVE_MESSAGE", label: "Erster Liebesbaum-Eintrag" },
        ],
      },
      { name: "condition_value", label: "Bedingungswert (z.B. Weg-ID oder Anzahl)", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  feature_cards: {
    label: "Besonderes (Startseite)",
    scoped: true,
    fields: [
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "subtitle", label: "Untertitel", type: "text" },
      { name: "image", label: "Bild", type: "image" },
      {
        name: "link_type",
        label: "Verlinkung",
        type: "select",
        options: [
          { value: "LOVE_TREE", label: "Liebesbaum" },
          { value: "WALK", label: "Weg" },
          { value: "CHALLENGE", label: "Challenge" },
          { value: "GAME", label: "Spiel" },
          { value: "PLACE", label: "Ort" },
          { value: "URL", label: "Externer Link" },
        ],
      },
      { name: "link_value", label: "Ziel (ID oder URL)", type: "text" },
      { name: "order", label: "Reihenfolge", type: "text" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
  love_tree_configs: {
    label: "Liebesbaum",
    scoped: true,
    fields: [
      { name: "title", label: "Titel", type: "text", required: true },
      { name: "hero_image", label: "Header-Bild", type: "image" },
      { name: "intro_text", label: "Introtext", type: "textarea" },
      { name: "outro_text", label: "Abschlusstext", type: "textarea" },
      { name: "enabled", label: "Aktiviert", type: "boolean" },
      { name: "active", label: "Aktiv", type: "boolean" },
    ],
  },
};

export const MODULE_TYPES = [
  "START",
  "INFO",
  "ENTDECKUNGSFENSTER",
  "WEGWAHL",
  "CODE_SUCHE",
  "FUNDSTUECK",
  "COMMUNITY_FRAGE",
  "TEXT_EINGABE",
  "AUDIO",
  "FOTO",
  "NACHRICHT_KETTE",
  "TEXT_ODER_AUDIO",
  "GEDANKENIMPULS",
  "CHALLENGE",
  "ACHIEVEMENT_PROGRESS",
  "FINALE",
];
